/* src/app/dynamic-forms/form-view/form-view.component.scss */
.view-container {
  display: flex;
  flex-direction: column;
}
.view-container > * {
  width: 100%;
}
.view-container-tab {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}
.view-container-tab > * {
  width: 50%;
}
.mat-tab-label-active {
  opacity: 1;
}
/*# sourceMappingURL=form-view.component.css.map */
